import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../../i18n/I18nContext";
import { ContactInfo } from "../../Utils/Data";

function Footer() {
  const { t, isRtl } = useI18n();

  return (
    <>
      <div
        className="ltn__call-to-action-area call-to-action-6 before-bg-bottom"
        data-bs-bg="img/1.jpg--"
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-6 ltn__secondary-bg position-relative text-center---">
                <div className="coll-to-info text-color-white">
                  <h1>{t("footer.ctaTitle")}</h1>
                  <p>{t("footer.ctaSubtitle")}</p>
                </div>
                <div className="btn-wrapper">
                  <Link className="btn btn-effect-3 btn-white" to="/property">
                    {t("footer.exploreProperties")} <i className="icon-next" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer className="ltn__footer-area">
        <div className="footer-top-area section-bg-2 plr--5">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-3 col-md-6 col-sm-6 col-12">
                <div className="footer-widget footer-about-widget">
                  <div className="footer-logo">
                    <div className="site-logo">
                      <span className="qtech-header-logo-window qtech-footer-logo-window">
                        <img src="/img/final-logo.svg" alt="Logo" className="qtech-header-logo qtech-header-logo-home-final" />
                      </span>
                    </div>
                  </div>
                  <p>{t("footer.aboutBlurb")}</p>
                  <div className="footer-address">
                    <ul>
                      <li>
                        <div className="footer-address-icon">
                          <i className="icon-placeholder" />
                        </div>
                        <div className="footer-address-info">
                          <p>{ContactInfo.address}</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className="ltn__social-media mt-20">
                    <ul>
                      <li>
                        <a href={ContactInfo.facebook} title="Facebook" target="_blank" rel="noreferrer">
                          <i className="fab fa-facebook-f" />
                        </a>
                      </li>
                      <li>
                        <a href={ContactInfo.X} title="X" target="_blank" rel="noreferrer">
                          <i className="fab fa-twitter" />
                        </a>
                      </li>
                      <li>
                        <a href={ContactInfo.instagram} title="Instagram" target="_blank" rel="noreferrer">
                          <i className="fab fa-instagram" />
                        </a>
                      </li>
                      <li>
                        <a href={ContactInfo.tiktok} title="TikTok" target="_blank" rel="noreferrer">
                          <i className="fab fa-tiktok" />
                        </a>
                      </li>
                      <li>
                        <a href={ContactInfo.snapchat} title="Snapchat" target="_blank" rel="noreferrer">
                          <i className="fab fa-snapchat-ghost" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-xl-3 col-md-6 col-sm-6 col-12">
                <div className="footer-widget footer-menu-widget clearfix">
                  <h4 className="footer-title">{t("footer.company")}</h4>
                  <div className="footer-menu">
                    <ul>
                      <li>
                        <Link to="/about">{t("footer.linkAbout")}</Link>
                      </li>
                      <li>
                        <Link to="/services">{t("footer.linkServices")}</Link>
                      </li>
                      <li>
                        <Link to="/property">{t("footer.linkProperty")}</Link>
                      </li>
                      <li>
                        <Link to="/blogs">{t("footer.linkBlogs")}</Link>
                      </li>
                      <li>
                        <Link to="/contact">{t("footer.linkContact")}</Link>
                      </li>
                      <li>
                        <a href="https://qtech-admin-ane2tndz6-umar-guls-projects.vercel.app/auth" target="_blank" rel="noreferrer">
                          Administrator
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-xl-3 col-md-6 col-sm-6 col-12">
                <div className="footer-widget footer-menu-widget clearfix">
                  <h4 className="footer-title">{t("footer.services")}</h4>
                  <div className="footer-menu">
                    <ul>
                      <li>
                        <Link to="/property-management-saudi-arabia">{t("footer.linkPropertyMgmt")}</Link>
                      </li>
                      <li>
                        <Link to="/real-estate-brokerage-saudi-arabia">{t("footer.linkBrokerage")}</Link>
                      </li>
                      <li>
                        <Link to="/real-estate-marketing-saudi-arabia">{t("footer.linkMarketing")}</Link>
                      </li>
                      <li>
                        <Link to="/property-maintenance-operations-saudi-arabia">{t("footer.linkMaintenance")}</Link>
                      </li>
                      <li>
                        <Link to="/property-development-saudi-arabia">{t("footer.linkDevelopment")}</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-xl-3 col-md-6 col-sm-12 col-12">
                <div className="footer-widget">
                  <h4 className="footer-title">{t("footer.contact")}</h4>
                  <div className="footer-address">
                    <ul>
                      <li>
                        <div className="footer-address-icon">
                          <i className="icon-home" />
                        </div>
                        <div className="footer-address-info">
                          <p>{t("footer.companyName")}</p>
                        </div>
                      </li>
                      <li>
                        <div className="footer-address-icon">
                          <i className="icon-call" />
                        </div>
                        <div className="footer-address-info">
                          <p>
                            <a href={`tel:${ContactInfo.contact_phone}`}>{ContactInfo.contact_phone}</a>
                          </p>
                        </div>
                      </li>
                      <li>
                        <div className="footer-address-icon">
                          <i className="icon-mail" />
                        </div>
                        <div className="footer-address-info">
                          <p>
                            <a href={`mailto:${ContactInfo.contact_email}`}>{ContactInfo.contact_email}</a>
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="ltn__copyright-area ltn__copyright-2 section-bg-2 plr--5">
          <div className="container-fluid ltn__border-top-2">
            <div className="row">
              <div className="col-md-6 col-12">
                <div className="ltn__copyright-design clearfix">
                  <p>
                    {t("footer.rights")} <span className="current-year" />
                  </p>
                </div>
              </div>
              <div className="col-md-6 col-12 align-self-center">
                <div className={`ltn__copyright-menu ${isRtl ? "text-start" : "text-end"}`}>
                  <p className="mb-0">{t("footer.serviceArea")}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;